import type { ReactNode } from 'react'
import { useFieldContext } from '@/lib/form-contexts'
import { Checkbox, type CheckboxProps } from '../ui/checkbox'
import { Label } from '../ui/label'
import { useIsReadOnly } from '@/lib/casl'

export type CheckboxInputProps = CheckboxProps & {
  label?: ReactNode
}

export default function CheckboxInput({ id, label, disabled, ...props }: CheckboxInputProps) {
  const field = useFieldContext<NonNullable<CheckboxProps['checked']>>()
  const { isReadOnly } = useIsReadOnly()
  const isDisabled = disabled || isReadOnly

  return (
    <div className="inline-flex items-center gap-2">
      <Label htmlFor={id || field.name}>
        <Checkbox
          id={id || field.name}
          name={field.name}
          // The Checkbox component is a button under the hood
          // It needs type="buttom" to prevent accidental form submissions
          type="button"
          checked={field.state.value}
          onCheckedChange={(isChecked) => field.handleChange(isChecked)}
          disabled={isDisabled}
          {...props}
        />
        <span className={isDisabled ? 'text-muted-foreground' : ''}>{label}</span>
      </Label>
    </div>
  )
}
